import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import Logo from "../../../../assets/logo/SCGC Logo_White.png";
// const drawerWidth = Number(process.env.REACT_APP_DRAWER_WIDTH || 240);
// const logoRatio = Number(process.env.EACT_APP_LOGO_RATIO || 0.5);
const AppMenuHeaderStyled = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    height: 58,
    marginTop: 10,
    marginBottom: 10,
    "& img": {
        width: "125px",
    },
    position: "relative",
}));

const VersionContainerStyled = styled("div")(() => ({
    position: "absolute",
    bottom: "-5px",
}));

const AppMenuHeader = () => {
    return (
        <AppMenuHeaderStyled data-testid="app-logo">
            {/* App Logo */}
            <img data-testid="test-app-logo" src={Logo} alt="scg-logo" />
            <VersionContainerStyled>
                <Typography variant="caption">{process.env.REACT_APP_VERSION}</Typography>
            </VersionContainerStyled>
            {/* <img data-testid="test-logo" src={Logo} alt="logo" style={{ width: drawerWidth * logoRatio }} /> */}
        </AppMenuHeaderStyled>
    );
};

export default AppMenuHeader;
